"use client";

import { useState, useEffect } from "react";
import { HiOutlineExclamationTriangle } from "react-icons/hi2"; // Warning icon from image
import { IoTrashOutline } from "react-icons/io5"; // Trash icon
import styles from "../css/allergies-overview.module.css";
import { useConsultation } from "../../../../context/ConsultationContext";

export default function AllergiesOverview({ patientData = {} }) {
  const [allergies, setAllergies] = useState([{ name: "" }]);
  const { getStepDraft, setStepDraft } = useConsultation();

  // Load from draft or patient data on mount
  useEffect(() => {
    const draft = getStepDraft("patientOverview", null);
    const draftAllergies = draft?.allergies;
    
    if (draftAllergies && Array.isArray(draftAllergies) && draftAllergies.length > 0) {
      const cleaned = draftAllergies.map((a) => ({ name: (a ?? "").toString() })).filter((a) => a.name.trim());
      setAllergies(cleaned.length ? cleaned : [{ name: "" }]);
    } else {
      const raw = patientData.allergies;
      if (raw == null) {
        setAllergies([{ name: "" }]);
        return;
      }
      if (Array.isArray(raw)) {
        const cleaned = raw.map((a) => ({ name: (a ?? "").toString() })).filter((a) => a.name.trim());
        setAllergies(cleaned.length ? cleaned : [{ name: "" }]);
        return;
      }
      const asString = String(raw);
      const parts = asString
        .split(/\r?\n|,/)
        .map((s) => s.trim())
        .filter(Boolean)
        .map((name) => ({ name }));
      setAllergies(parts.length ? parts : [{ name: "" }]);
    }
  }, [patientData.allergies]); // eslint-disable-line react-hooks/exhaustive-deps

  // Save to draft whenever allergies change
  useEffect(() => {
    const allergyNames = allergies.map(a => a.name).filter(Boolean);
    setStepDraft("patientOverview", (prev) => ({
      ...(prev || {}),
      allergies: allergyNames,
    }));
  }, [allergies]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAllergyChange = (index, value) => {
    const updated = [...allergies];
    updated[index].name = value;
    setAllergies(updated);
  };

  const addAllergy = () => {
    setAllergies([...allergies, { name: "" }]);
  };

  const deleteAllergy = (index) => {
    if (allergies.length === 1) {
      setAllergies([{ name: "" }]);
      return;
    }
    setAllergies(allergies.filter((_, i) => i !== index));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HiOutlineExclamationTriangle className={styles.warningIcon} />
        <h3 className={styles.title}>Allergies</h3>
      </div>

      <div className={styles.list}>
        {allergies.map((allergy, index) => (
          <div key={index} className={styles.row}>
            <div className={styles.inputWrapper}>
              <input
                type="text"
                className={styles.allergyInput}
                value={allergy.name}
                onChange={(e) => handleAllergyChange(index, e.target.value)}
                placeholder="Enter allergy..."
              />
            </div>
            <button 
              className={styles.deleteBtn} 
              onClick={() => deleteAllergy(index)}
              title="Delete Allergy"
            >
              <IoTrashOutline size={18} />
            </button>
          </div>
        ))}
      </div>

      <button className={styles.addBtn} onClick={addAllergy}>+</button>
    </div>
  );
}